import * as React from "react";
import StudentController from "../api/StudentController";
import "react-bootstrap-typeahead/css/Typeahead.css";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as studentActionCreator from "../redux/actions/student";
import * as appActionCreator from "../redux/actions/app";

interface SearchBarAdvisorState
{
    options?: Student[];
    isLoading: boolean;
    minLength: number;
    promptText: string;
    autoFocus: boolean;
}

interface SearchBarAdvisorProps
{
    isTopBar: boolean;
}

class SearchBarAdvisor extends React.Component<SearchBarAdvisorProps, SearchBarAdvisorState>
{
    studentController = new StudentController();

    constructor(props: SearchBarAdvisorProps)
    {
        super(props);

        this.state = {
            options: undefined,
            isLoading: true,
            minLength: 0,
            promptText: "Fetching students, please wait...",
            autoFocus: this.props.isTopBar ? false : true
        };
    }

    async componentDidMount()
    {
        await this.getStudents();
    }

    getStudents = async () =>
    {
        const data = await this.studentController.getStudents("", true);

        this.setState(
            {
                options: data.students,
                isLoading: false
            });
    }

    onChange = async (student: Student): void => 
    {
        if (student != null) 
        {
            const instance = this._typeahead.getInstance();

            if (this.props.role == "academicAdvisor")
            {
                this.setState({ isLoading: true });
                const studentSettings = await this.studentController.getPrivacySettingsInit(student.kerbId);
                this.props.appActions.setSettings(studentSettings);
            }

            const selectedStudent = { kerbId: student.kerbId, name: student.fullName };
            this.props.actions.selectStudent(selectedStudent);

            this.setState({ isLoading: false });
            instance.clear();
        }
    }

    render(): React.ReactNode 
    {
        return <div>
            <i className="far fa-search typeahead-icon"></i>
            {
                <AsyncTypeahead
                    {...this.state}
                    labelKey="fullName"
                    filterBy={["fullName", "kerbId"]}
                    id="Search"
                    useCache={false}
                    multiple={false}
                    placeholder="Search for Student Name, Kerb or MIT ID"
                    onChange={(e) => this.onChange(e[0] as Student)}
                    ref={(ref) => this._typeahead = ref}
                    renderMenuItemChildren={(option) => (
                        <b>{option.fullName}</b>
                    )}
                />
            }
        </div>;
    }
}

const mapDispatchToProps = (dispatch: any) => ({
    actions: bindActionCreators(studentActionCreator, dispatch),
    appActions: bindActionCreators(appActionCreator, dispatch)
});

const mapStateToProps = (state: any) => ({
    role: state.app.user.role
});

export default connect(mapStateToProps, mapDispatchToProps)(SearchBarAdvisor);